export var Sport;
(function (Sport) {
    Sport["AmericanFootball"] = "AmericanFootball";
    // AquaticSports = 'AquaticSports',
    // Athletics = 'Athletics',
    Sport["AustralianRules"] = "AustralianRules";
    Sport["Badminton"] = "Badminton";
    Sport["Bandy"] = "Bandy";
    Sport["Baseball"] = "Baseball";
    Sport["Basketball"] = "Basketball";
    Sport["BeachSoccer"] = "BeachSoccer";
    Sport["BeachVolleyball"] = "BeachVolleyball";
    // BoatRacing = 'BoatRacing',
    Sport["CombatSport"] = "CombatSport";
    Sport["Cricket"] = "Cricket";
    Sport["Curling"] = "Curling";
    // Cycling = 'Cycling',
    Sport["Darts"] = "Darts";
    Sport["Equestrian"] = "Equestrian";
    Sport["Floorball"] = "Floorball";
    Sport["Football"] = "Football";
    Sport["Futsal"] = "Futsal";
    Sport["Golf"] = "Golf";
    // Gymnastics = 'Gymnastics',
    Sport["Handball"] = "Handball";
    Sport["Hockey"] = "Hockey";
    Sport["Icehockey"] = "Icehockey";
    Sport["Kabaddi"] = "Kabaddi";
    Sport["Lacrosse"] = "Lacrosse";
    // Motorsport = 'Motorsport',
    Sport["Rugby"] = "Rugby";
    Sport["Snooker"] = "Snooker";
    Sport["Squash"] = "Squash";
    // Surfing = 'Surfing',
    Sport["TableTennis"] = "TableTennis";
    Sport["Tennis"] = "Tennis";
    Sport["Volleyball"] = "Volleyball";
    Sport["Waterpolo"] = "Waterpolo";
    // Wintersports = 'Wintersports',
    Sport["CallOfDuty"] = "CallOfDuty";
    Sport["CounterStrikeGO"] = "CounterStrikeGO";
    Sport["DefenseOfTheAncients"] = "DefenseOfTheAncients";
    Sport["HonorOfKings"] = "HonorOfKings";
    Sport["LeagueOfLegends"] = "LeagueOfLegends";
    Sport["Overwatch"] = "Overwatch";
    Sport["RainbowSixSiege"] = "RainbowSixSiege";
    Sport["RocketLeague"] = "RocketLeague";
    Sport["Starcraft2"] = "Starcraft2";
    Sport["Valorant"] = "Valorant";
})(Sport || (Sport = {}));
export var TradingType;
(function (TradingType) {
    TradingType["PreMatch"] = "PreMatch";
    TradingType["Live"] = "Live";
    TradingType["InPause"] = "InPause";
    TradingType["Outright"] = "Outright";
})(TradingType || (TradingType = {}));
export var ContestStatusName;
(function (ContestStatusName) {
    ContestStatusName["Pregame"] = "Pregame";
    ContestStatusName["Canceled"] = "Canceled";
    ContestStatusName["Interrupted"] = "Interrupted";
    ContestStatusName["Paused"] = "Paused";
    ContestStatusName["Final"] = "Final";
    ContestStatusName["Aborted"] = "Aborted";
    ContestStatusName["Running"] = "Running";
})(ContestStatusName || (ContestStatusName = {}));
export var InterruptionReason;
(function (InterruptionReason) {
    InterruptionReason["Timeout"] = "Timeout";
    InterruptionReason["TechnicalTimeout"] = "TechnicalTimeout";
    InterruptionReason["Medical"] = "Medical";
    InterruptionReason["RainDelay"] = "RainDelay";
})(InterruptionReason || (InterruptionReason = {}));
export var BettingType;
(function (BettingType) {
    BettingType["MatchWin"] = "MatchWin";
    BettingType["HeadToHead"] = "HeadToHead";
    BettingType["Spread"] = "Spread";
    BettingType["Handicap"] = "Handicap";
    BettingType["OddsBoost"] = "OddsBoost";
    BettingType["OverUnder"] = "OverUnder";
    BettingType["CorrectScore"] = "CorrectScore";
    BettingType["PlayerToScore"] = "PlayerToScore";
    BettingType["FirstPlayerToScore"] = "FirstPlayerToScore";
    BettingType["Place"] = "Place";
    BettingType["TopBowler"] = "TopBowler";
    BettingType["TopBatsman"] = "TopBatsman";
})(BettingType || (BettingType = {}));
export var OutcomeType;
(function (OutcomeType) {
    OutcomeType["Home"] = "Home";
    OutcomeType["Draw"] = "Draw";
    OutcomeType["Away"] = "Away";
    OutcomeType["Over"] = "Over";
    OutcomeType["Under"] = "Under";
    OutcomeType["OtherResultOutcome"] = "OtherResultOutcome";
    OutcomeType["Yes"] = "Yes";
    OutcomeType["No"] = "No";
})(OutcomeType || (OutcomeType = {}));
export var SortBy;
(function (SortBy) {
    SortBy["Begin"] = "Begin";
    SortBy["Popularity"] = "Popularity";
})(SortBy || (SortBy = {}));
//# sourceMappingURL=Types.js.map